import React from "react";
import { Redirect, useLocation } from "react-router-dom";

// "/" (login), "/forgetPassword", and "/confirmPassword/:data" are the only
// pages reachable without a token. Everything else in the Switch is admin-only.
export const isPublicAdminPath = (pathname) =>
  pathname === "/" ||
  pathname === "/forgetPassword" ||
  pathname.startsWith("/confirmPassword/");

// One route-guard wrapper around the whole <Switch>, rather than guarding
// each of the ~100 routes individually. Stores the attempted path in
// "AdminCurrentUrl" so signup.js's login handler can return the admin there.
const RequireAuth = ({ children }) => {
  const location = useLocation();

  if (isPublicAdminPath(location.pathname)) {
    return children;
  }

  const hasToken = !!localStorage.getItem("token");
  if (!hasToken) {
    localStorage.setItem(
      "AdminCurrentUrl",
      `${location.pathname}${location.search}`
    );
    return <Redirect to="/" />;
  }

  return children;
};

export default RequireAuth;
